import React from 'react'
import pakaiClass from 'pakai-class'
import styles from './dummyMenu.module.scss'

const MenuSection = ({
  title,
  items = [],
  isActive = true,
  onToggle,
  onItemClick
}) => {
  return (
    <div className={styles.menuSection}>
      <div 
        className={styles.sectionHeader}
        onClick={onToggle}
      >
        <h3 className={styles.sectionTitle}>{title}</h3>
      </div>
      
      {isActive && (
        <div className={styles.menuItems}>
          {items.map((item) => (
            <div 
              key={item.id}
              className={pakaiClass(
                styles.menuItem,
                item.type === 'table' && 'cursor-pointer'
              )}
              onClick={() => onItemClick && onItemClick(item)}
            >
              <div className={styles.itemLabel}>
                {item.label}
              </div>
              {item.description && (
                <div className={styles.itemDescription}>
                  {item.description}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default MenuSection